import AppData from '../../Model/MerchantAppData';
import BaseFirebaseRepository from './BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()
export default class FirebasePrintJobRepository extends BaseFirebaseRepository {
    /**
     * @param {*} app
     * @return {FirebasePrintJobRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = AppData.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new FirebasePrintJobRepository(app)
        }
        return instances[app]
    }
    constructor(app) {
        super(app)
    }
    getRef = () => {
        if (!merchant_id) {
            throw "Invalid 'merchant_id'"
        }
        return firebase.database().ref(firebase_path + '/firebase_print_jobs/')
            .orderByChild("merchant_id")
            .equalTo(parseInt(merchant_id))
    }
    getBaseObject = () => {
        return {}
    }
    getBaseObject = () => {
        return {}
    }

    logChildRemoved = (item) => {
        console.log(`Print job removed, ${item.id}`)
    }

    setJobPrinted = (printJobId, status = '') => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchant/api/print_job/${printJobId}/set_printed`,
                type    : 'post',
                data    : {
                    status
                },
                success : () => {
                    resolve()
                }
            })
            .fail(jqXHR => {
                if(jqXHR && jqXHR.statusText == 'abort') { return } // Cause by manual abort, no need show error

                let message = ""
                try {
                    let json = JSON.parse(jqXHR.responseText)
                    message = json["message"] || json[Object.keys(json)[0]] || "Fail to set print job as printed."
                }
                catch {

                }
                reject(message)
            })
        })

    }
}